import { blueprints } from '../blueprints/blueprints-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { machines } from '../machines/machines-sidecar'
import { IMachineData } from '../machines/machinesData'
import { stacks } from '../entities/stacks-sidecar'
import { distance } from '../lib/distance-sidecar'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'

export function createTask_build(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'build', {})
}
export function forceBuildMachine(i: number, j: number, d: IMachineData) {
  let mc = machines.create(d.type)
  machines.moveToTile(mc, scene.getContext().mapShip, i, j)
}

export function runTask_build(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'build')
  let m = jobLogger.assertReserved(job)

  // Are we at the right spot?
  if (!distance.isAt(m.i, m.j, task.i, task.j)) {
    return jobLogger.failTask(job, task, 'wrong spot')
  }

  let blueprintHere = blueprints.findAtSpot(m.i, m.j, (c) => true)

  // Blueprint went missing
  if (!blueprintHere) {
    return jobLogger.failTask(job, task, 'lost blueprint')
  }
  if (!blueprintHere.machineData && !blueprintHere.cargoType) {
    return jobLogger.failTask(job, task, 'no machine data or cargo type')
  }
  let ctx = scene.getContext()
  let t = tileMapShip.getTile(ctx.mapShip, m.i, m.j)
  let std = tilesDataShip.getStandard()
  if (!t || !t.dataFloor || !(t.dataFloor === std.floor)) {
    // No floor

    blueprints.kill(blueprintHere)
    return jobLogger.failTask(job, task, 'no floor')
  }

  if (blueprintHere.machineData) {
    let mc = machines.create(blueprintHere.machineData.type)
    machines.moveToTile(
      mc,
      scene.getContext().mapShip,
      blueprintHere.i,
      blueprintHere.j,
    )
  }
  // if (blueprintHere.cargoType) {
  //   let st = stacks.create(blueprintHere.cargoType)
  //   stacks.moveToTile(
  //     st,
  //     scene.getContext().mapShip,
  //     blueprintHere.i,
  //     blueprintHere.j,
  //   )
  // }
  // tilesShip.setFloor(t, blueprintHere.tileData)

  blueprints.kill(blueprintHere)

  jobLogger.succeedTask(job, task)
}
